/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_BadgeInputs */

const zh_about_badge = /** @type {(inputs: About_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的使命`)
};

const en_about_badge = /** @type {(inputs: About_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Mission`)
};

const es_about_badge = /** @type {(inputs: About_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra misión`)
};

/**
* | output |
* | --- |
* | "Our Mission" |
*
* @param {About_BadgeInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const about_badge = /** @type {((inputs?: About_BadgeInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_BadgeInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_badge(inputs)
	if (locale === "en") return en_about_badge(inputs)
	return es_about_badge(inputs)
});